import {
  DEFAULT_MAX_ASSET_NAME_LENGTH,
  MAX_ASSET_DESCRIPTION_WORDS,
} from "./text-limits";

// Both caps are owned by `config/questionnaire-text-limits.json`.
export { DEFAULT_MAX_ASSET_NAME_LENGTH, MAX_ASSET_DESCRIPTION_WORDS };

/** Count whitespace-separated words (empty / whitespace-only → 0). */
export function countWords(value: unknown): number {
  if (typeof value !== "string") {
    return 0;
  }
  const trimmed = value.trim();
  if (!trimmed) {
    return 0;
  }
  return trimmed.split(/\s+/).length;
}

export function isWithinAssetDescriptionWordLimit(value: unknown): boolean {
  if (value === undefined || value === null) {
    return true;
  }
  if (typeof value !== "string") {
    return false;
  }
  return countWords(value) <= MAX_ASSET_DESCRIPTION_WORDS;
}

/**
 * Clamp text to the first `maxWords` words, preserving intervening whitespace
 * when possible. Used by the builder so users cannot paste past the limit.
 */
export function clampToMaxWords(
  value: string,
  maxWords: number = MAX_ASSET_DESCRIPTION_WORDS,
): string {
  if (maxWords <= 0) {
    return "";
  }
  const parts = value.match(/\S+|\s+/g);
  if (!parts) {
    return value;
  }
  let wordCount = 0;
  let out = "";
  for (const part of parts) {
    if (/\S/.test(part)) {
      if (wordCount >= maxWords) {
        break;
      }
      wordCount += 1;
      out += part;
    } else if (wordCount > 0 && wordCount < maxWords) {
      // Keep whitespace only between kept words (not trailing after the last).
      out += part;
    }
  }
  return out;
}
